import React, { createContext, useState, useCallback, useContext } from "react";
import usePusherSub                                                from "~/hooks/usePusherSub";
import UserContext                                                 from "~/contexts/UserContext";

export const BadgeContext = createContext({});

export const BadgeProvider = ({ children }) => {
  const { user } = useContext(UserContext);

  const [badges, setBadges] = useState({
    calls: 0,
    voicemails: 0,
    message: 0,
    ...user.badges,
  });

  const onBadgeEvent = useCallback(
    (badgePayload) => setBadges(badgePayload),
    [setBadges]
  );

  usePusherSub({
    channel: `user-${user.id}`,
    event: "badge-updated",
    handler: onBadgeEvent,
  });

  return (
    <BadgeContext.Provider
      value={{
        ...badges
      }}
    >
      {children}
    </BadgeContext.Provider>
  );
};
